import Vue from 'vue'
import axios from './axios'

export default (route, query) => {

    return axios
        .post(route, query)
        .then(result => {

            if (result.data.errors) throw result.data.errors[0].message

            return result.data.data

        })
        .catch(error => {

            if (error.response) {

                if (error.response.data.errors) throw error.response.data.errors[0].message

                const vm = new Vue()

                vm.$bvToast.toast(error.response.data, {
                    title: 'Error',
                    variant: 'warning'
                })

                throw error.response.data

            }

            throw error

        })

}